import React from "react";

export default function BalanceInfo({ balance }) {
  const formatMana = (value) => {
    return Math.round(value).toLocaleString();
  };

  return (
    <div className="balance-section">
      <h3>Current Balance</h3>
      <p>{formatMana(balance)}</p>
    </div>
  );
}
